import React, { Component } from 'react';

import { Grid, Drawer } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import CustomTypo from '../../components/CustomTypo';

import { BackOnPrimaryIcon } from '../../components/icons';
import renderHTML from 'react-render-html';
import DrawerCustom from '../../components/DrawerCustom';
import { custom_assets, domainName, portal_config } from '../../../portal.config';
import { ScrollMenu } from 'react-horizontal-scrolling-menu';
import { portalCfg } from '../../../portal.router.config';
var path = custom_assets[domainName] && custom_assets[domainName].customImage && custom_assets[domainName].customImage.background  ? portalCfg.publicPath + "/custom_assets" : portalCfg.publicPath + "/assets";

const styles = theme => ({
    '@global': {
        "*::-webkit-scrollbar": {
            width: theme.spacing(1),
            height: theme.spacing(1.5),
        },
        "*::-webkit-scrollbar-thumb": {
            background: theme.palette.background.onCard,
        },
        "*::-webkit-scrollbar-track": {
            background: theme.palette.background.primary
        },
    },
    boxItemContent: {
        padding: theme.spacing(4),
        marginBottom: theme.spacing(1.5),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        cursor: 'pointer',
        position:'relative'
    },
    footer:{
        position:'absolute',
        bottom: theme.spacing(2)
    },
    partners: {
        position: 'absolute',
        bottom: theme.spacing(15),
        width: '92%',
    },
    partner_item: {
        display: 'flex',
        touchAction: "manipulation",
    },
    img_partner: {
        maxHeight: theme.spacing(30),
        borderRadius: theme.spacing(2),
        marginRight: theme.spacing(2),
        touchAction: "manipulation",
    },
    row: {
        margin: theme.spacing(2, 0, 2, 0)
    },
});
function AboutView(props){
    const {classes, t, about_details, partner_creatives } = props
    var content = about_details && about_details.about && about_details.about.content ? about_details.about.content : ""
    
    return (
        <div>
            <DrawerCustom
                open={props.open}
                onClose={()=>props.onCloseItem('about')}
                title = {t('about_title')}
                enableBack
                children={
                   <Grid item>
                        <Grid xs={12} item className={classes.boxItemContent}> 
                            <div dangerouslySetInnerHTML={{__html: content}}/>
                        </Grid>
                        <Grid item xs={12} className={classes.partners}>
                            {partner_creatives && partner_creatives.length > 0 && 
                                <Grid item xs={12}>
                                    <Grid item xs={12} style={{marginBottom: 10}}>
                                        <CustomTypo variant="subtitle2" color='onPrimary'>{t('our_partners')}</CustomTypo>
                                    </Grid>
                                    <div className='App'>
                                        <ScrollMenu 
                                        alignCenter={false}>
                                            {partner_creatives.map((item,index) => {
                                                let img = item && item.url ? item.url : path + "/images/background.png";
                                                return (
                                                    <Grid item key={index} classname={classes.partner_item}>
                                                        <img src={img} alt="Partner Item" className={classes.img_partner}></img>
                                                    </Grid>
                                                );
                                                })
                                            }
                                        </ScrollMenu>
                                    </div>
                                </Grid>
                            }
                        </Grid>
                        
                        <Grid item xs={12} container justify='center'>
                            <CustomTypo variant="body1" center color='onPrimary' className={classes.footer}>{portal_config.copyright}</CustomTypo>
                        </Grid>
                </Grid>}
            />
        </div>
    );
}
export default withStyles(styles)(withTranslation()(AboutView));